import { render, staticRenderFns } from "./plantHeight-leafLength-leafWidth.vue?vue&type=template&id=84ccce98&scoped=true&"
import script from "./plantHeight-leafLength-leafWidth.vue?vue&type=script&lang=js&"
export * from "./plantHeight-leafLength-leafWidth.vue?vue&type=script&lang=js&"
import style0 from "./plantHeight-leafLength-leafWidth.vue?vue&type=style&index=0&id=84ccce98&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ccce98",
  null
  
)

export default component.exports